import { render, staticRenderFns } from "./ChangeTransporter.vue?vue&type=template&id=53a02534&"
import script from "./ChangeTransporter.vue?vue&type=script&lang=js&"
export * from "./ChangeTransporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports